import type { JSX } from 'react';

import { CertificationMeta } from '@/components/domain/CertificationMeta';
import { certifications } from '@/content/certifications';

/**
 * Derived from `certifications.ts` rather than written out, so adding or dating
 * a certification updates this sentence too.
 *
 * All GlobalLogic entries are the AI certifications; if a non-AI one is ever
 * added for that issuer, this filter needs an explicit marker instead.
 */
const aiCertifications = certifications.filter(
  (certification) => certification.issuer === 'GlobalLogic',
);

export function AiCredentialsNote(): JSX.Element | null {
  if (aiCertifications.length === 0) {
    return null;
  }

  return (
    <div className="max-w-2xl text-sm text-subtle">
      <p>
        Formal grounding alongside the delivery work — {aiCertifications.length} GlobalLogic AI
        certifications:
      </p>
      <ul className="mt-3 flex flex-col gap-1.5">
        {aiCertifications.map((certification) => (
          <li key={certification.id} className="flex gap-2">
            <span
              aria-hidden="true"
              className="mt-2 size-1.5 shrink-0 rounded-full bg-line-strong"
            />
            <span>
              {certification.name} <span aria-hidden="true">—</span>{' '}
              <CertificationMeta certification={certification} />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
